import { render, staticRenderFns } from "./StepAdminProfileNavigationDrawer.vue?vue&type=template&id=06523c14"
import script from "./StepAdminProfileNavigationDrawer.vue?vue&type=script&lang=js"
export * from "./StepAdminProfileNavigationDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports